var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-element"},[_c('label',{attrs:{"for":_vm.inputId}},[_c('span',[_vm._v(_vm._s(_vm.label))]),_vm._t("default")],2),_c('bf-help-error',[_vm._t("help-error")],2),_c('bf-help-text',[_vm._t("help-text")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }